import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplierEdiComponent } from './supplier-edi.component';
import { LayoutModule } from '@shabic/shared';
import { UiModule } from '@shabic/ui';
import { MatDialogModule } from '@angular/material/dialog';
// Import any shared modules (e.g., ShabicLayoutModule, ShabicButtonModule) as needed

@NgModule({
  declarations: [SupplierEdiComponent],
  imports: [CommonModule, LayoutModule, UiModule, MatDialogModule],
  exports: [SupplierEdiComponent],
})
export class SupplierEdiModule {} 